export default "__VITE_ASSET__fC9IHDhQ__"